export const colorPrimary = "#009688"; // Teal 500
export const colorPrimaryDark = "#00695C"; // Teal 800
export const colorPrimaryLight = "#E0F2F1"; // Teal 100

export const colorPrimaryTextDark = "#000"; //"#004D40";
export const colorPrimaryTextLight = "#fff"; //"#E0F2F1";

export const colorSecondary = "#9E9E9E"; //Gray 500
export const colorSecondaryDark = "#424242"; //Gray 800
export const colorSecondaryLight = "#FAFAFA"; //Gray 100

//export const colorPrimaryText = "";

export const colorSecondaryTextDark = "#455A64";
// export const colorSecondaryTextLight ="";

export const RED_A100 = "#ff5252"; // "#FF8A80";
export const GREEN_100 = "#66BB6A"; //"#C8E6C9";
export const BLUE_100 = "#00BCD4"; //"#BBDEFB";
export const PINK_100 = "#EC407A"; //"#FF80AB";
export const WHITE = "#FFF";
export const YELLOW_A200 = "#FFEE58"; //"#FFD740";
export const BG_COLORS = [RED_A100, GREEN_100, BLUE_100, PINK_100, YELLOW_A200];

export const PURPLE_GRADIENT_TO_RIGHT = "linear-gradient(to right, #673ab7, #311B92)";
export const PURPLE_GRADIENT_TO_LEFT = "linear-gradient(to left, #673ab7, #311B92)";
const mycolor = "#673ab7";